<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          Role Lists
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-col cols="12" sm="6" md="4">
            <template>
              <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </template>
          </v-col>
          <v-col cols="12" sm="6" md="1">
            <template>
              <v-row align="center" justify="space-around">
                <v-btn depressed color="info" @click="addItem">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-col>
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="headers"
              :items="roles"
              class="elevation-1"
              :search="search"
              dense
              mobile-breakpoint="0"
              :loading="loading_status"
              loading-text="Loading... Please wait"
          >
            <template v-slot:item.actions="{ item }">
              <v-tooltip top v-if="specialPower === '1'">
                <template v-slot:activator="{on}">
                  <v-chip
                      @click="editItem(item)"
                      dark
                      v-on="on"
                      class="ma-2"
                      color="grey"
                      label
                      outlined
                      small
                      :class="{'d-none': item.id === 1 && specialPower !== '1'}"
                  >
                    <v-icon> mdi-pencil</v-icon>
                  </v-chip>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top v-if="checkPermissionHasOrNot(ROLE_DELETE)">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      @click="deleteData(item)"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      class="ma-2"
                      color="error"
                      label
                      outlined
                      small
                      :class="item.id === 1 ? 'd-none':''"
                  >
                    <v-icon> mdi-delete</v-icon>
                  </v-chip>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";


export default {
  data() {
    return {
      search: "",
      loading_status: true,
      login_user_id: localStorage.getItem("userId"),
      specialPower: localStorage.getItem("specialPower"),
      headers: [
        {text: "ID", align: "start", value: "id",},
        {text: "Name", value: "name"},
        {text: "Total Permission", value: "role_permissions_count"},
        {text: "Action", value: "actions", sortable: false},
      ],
      submitData: {
        id: '',
        name: '',
      },
      roles: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        }, {
          text: "Users & Roles",
          disabled: false,
          href: "/",
        }, {
          text: "Role List",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getRoleList();
    },
    getRoleList() {
      atshq
          .get("users/roles")
          .then((response) => {
            this.roles = response.data.roles;
            this.loading_status = false;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
            this.loading_status = false;
          });
    },
    addItem() {
      this.$router.push("/users/roles/add-role-permission");
    },
    editItem(item) {
      this.$router.push("/users/roles/add-role-permission/"+item.id);
    },
    deleteData(item) {
      if (confirm("are you sure?"))
        atshq
            .delete("users/roles/" + item.id)
            .then((response) => {
              this.$noty.success(response.data.message);
              this.getRoleList();
            })
            .catch((e) => {
              this.$noty.error(e.response.data.message);
            });
    },
    dialog(){
      this.addEditModal = false
    }
  },
};
</script>